var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        on: {
          click: function($event) {
            _vm.$emit("close")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-box",
            class: _vm.size,
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header with-border-bottom" }, [
              _c(
                "div",
                { staticClass: "modal-title" },
                [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
                  _vm._v(" "),
                  _vm._t("header")
                ],
                2
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "modal-subtitle",
                domProps: { innerHTML: _vm._s(_vm.subtitle) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [_vm._t("footer")], 2)
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-180e5d82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180e5d82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Modal.vue
// module id = null
// module chunks = 